/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Icon, ICON_SIZE } from "../Icon";

export interface IFloatingPanelHeaderProps extends React.ComponentPropsWithRef<"div"> {
	className?: string;
	onClose?: () => void;
}

export const FloatingPanelHeader = React.forwardRef<HTMLDivElement, IFloatingPanelHeaderProps>(
	({ children, className, onClose, ...props }, ref) => {
		const baseClass = BEM("edt-floating-panel-header");

		if (className) {
			baseClass.add(className);
		}

		return (
			<div className={baseClass.toClassName()} ref={ref} {...props}>
				<div className={baseClass.element("title").toClassName()}>{children}</div>

				<div className={baseClass.element("fill").toClassName()} />

				<div className={baseClass.element("close-btn").toClassName()} onClick={onClose}>
					<Icon name="mdi/close" size={ICON_SIZE.XSMALL} />
				</div>
			</div>
		);
	}
);
